module.exports = __webpack_public_path__ + "static/img/CAM-NYKO.63df871.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CAM-NYKO.jpg
// module id = rOt+
// module chunks = 0